export const closingFooter = {
  email: 'hey@immersivestudios.de',
  /** Footer statement, top left — one entry per line */
  title: ['Ready to be', 'explored?'],
  /** Label on the white email button */
  cta: 'hey@immersivestudios.de',
  /** Rendered as "Immersive Studios © <current year> All rights reserved" — the year is always live */
  copyrightHolder: 'Immersive Studios',
  copyrightSuffix: 'All rights reserved',
  links: [
    { label: 'Work', href: '#work' },
    { label: 'Services', href: '#services' },
    { label: 'Culture', href: '#culture' },
    { label: 'Clients', href: '#clients' },
  ],
  legal: [
    { label: 'Imprint', href: '/legal#imprint' },
    { label: 'Cookies', href: '/legal#cookies' },
    { label: 'Privacy Policy', href: '/legal#privacy' },
  ],
};
